export function objectToFormData<T extends Record<string | number | symbol, unknown>>(object: T) {
  const formData = new FormData()

  for (const [key, value] of Object.entries(object)) {
    if (!(typeof value === 'string' || value instanceof Blob)) {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value)
    }
  }

  return formData
}
